<!-- Page Banner -->
<div class="page-banner-area item-bg1">
    <div class="container">
        <div class="page-banner-content">
            <h2>FAQ</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>FAQ</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- FAQ -->
<section class="faq-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>FAQ</span>
            <h2>Asked Questions</h2>
            <div class="bar"></div>
        </div>

        <div class="faq-accordion">
            <ul class="accordion">
                <li class="accordion-item">
                    <a class="accordion-title active" href="javascript:void(0)"><i class='bx bx-plus'></i> What are the
                        services provided by MicroSync Technologies?</a>
                    <p class="accordion-content show">MicroSync Technologies provides software development services
                        such as Custom Software Development,
                        Web Application Development, Mobile Application Development, IT Consulting Services, Cloud
                        Computing, DevOps Automation, Software Prototyping, Data Analytics, Quality Assurance. For more
                        details please visit to our..<a routerLink="/testing-services">Services</a></p>
                </li>

                <li class="accordion-item">
                    <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> What are the
                        industries MicroSync Technologies have business understanding?</a>
                    <p class="accordion-content">MicroSync Technologies experts have domain knowledge in Banking,
                        Insurance, Healthcare, Education,
                        Transportation, Event Management, Cash Management, Social Media. For more
                        details please visit to our..<a routerLink="/industries">Industries</a></p>
                </li>

                <li class="accordion-item">
                    <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> What are the
                        technical languages or experties MicroSync Technologies have?</a>
                    <p class="accordion-content">MicroSync Technologies experts skilled professional in Windows, Web
                        frontend/backend, cloud,
                        database, automation, devops Technologies. For more
                        details please visit to our..<a routerLink="/technology-expertise">Expertise</a></p>
                </li>

                <li class="accordion-item">
                    <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> Does MicroSync
                        Technologies support existing legacy systems?</a>
                    <p class="accordion-content">MicroSync Technologies experts are capable to supporting existing
                        legacy systems as well as help
                        then to migrate to the new technologies.</p>
                </li>

                <li class="accordion-item">
                    <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> Where MicroSync
                        Technologies located?</a>
                    <p class="accordion-content">MicroSync Technologies is located in South Africa. We supports remote
                        working so that client dont need to pay extra attention on resource availibility.</p>
                </li>

                <li class="accordion-item">
                    <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> How resource sharing
                        works with MicroSync Technologies?</a>
                    <p class="accordion-content">MicroSync Technologies resources work on product based and service
                        based structure. We support
                        resource sharing per hour or once-off monthly billing.</p>
                </li>
            </ul>
        </div>
    </div>
</section>
<!-- End FAQ -->

<!-- FAQ Contact -->
<div class="faq-contact-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Questions</span>
            <h2>Do You Have Any Questions?</h2>
            <div class="bar"></div>
            <br />
            <a routerLink="/contact-us" class="default-btn">CONTACT US</a>
        </div>
    </div>
</div>
<!-- End FAQ Contact -->